import { Component, Input } from "@angular/core";

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";

import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { BaseComponent } from "../base.component";
import { Base, UserTypes } from "../_models/index";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";
import { autoFillForms } from "../_helpers/auto-fill-forms/auto-fill-forms";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Component({
  selector: "search",
  moduleId: module.id,
  templateUrl: "search.component.html",
  styleUrls: ["search.component.scss"],
})
export class SearchComponent extends BaseComponent {
  closeResult: string;
  model: any;
  modalReference: any;
  searching: boolean;
  searchFailed: boolean;
  hideSearchingWhenUnsubscribed = new Observable(
    () => () => (this.searching = false)
  );

  constructor(
    private modalService: NgbModal,
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
    autoFillForms(this, { shouldSubmit: true });
    this.searching = false;
  }

  public formatter = (child: { firstName: string; lastName: string }) =>
    child.firstName +
    (child.firstName &&
    child.firstName !== "" &&
    child.lastName &&
    child.lastName !== ""
      ? " "
      : "") +
    child.lastName;

  public run() {}

  public open(content) {
    this.clearSearch();
    let options: NgbModalOptions = {
      windowClass: "modal-opened searchChild",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  searchChild() {}

  clearSearch() {
    this.model = { firstName: "", lastName: "" };
    if (this.modalReference) this.modalReference.close();
  }

  selectRow(child) {}
  public $$devSearchChildFromInput() {
    setTimeout(() => {
      const inputField: HTMLInputElement =
        document.querySelector("#main-search-field");
      if (!inputField) {
        return;
      }
      inputField.focus();
    }, 100);
  }

  select(event) {
    let entity = event.item;
    this.clearSearch();
    if (entity.isParent) {
      this.dataService.registeredUser.next(entity);
      this.dataService.children.next(null);
      this.dataService.events.next(null);
    } else {
      this.dataService.registeredUser.next(null);
      let s = this.dataService.getUsersData(entity.id).subscribe();
      this.addObservable(s);
    }
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => (this.searching = true))
      .switchMap((term) =>
        this.dataService
          .search(term)
          .do(() => (this.searchFailed = false))
          .catch(() => {
            this.searchFailed = true;
            return of([]);
          })
      )
      .do(() => (this.searching = false))
      .merge(this.hideSearchingWhenUnsubscribed);
}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts